import { WecomRecovateMessageData } from "../../handler/wecom/ws-types";
import EventBus from "../event-bus";
const revocateMessageHook = new EventBus<WecomRecovateMessageData>(
  "revocateMessageHook"
);

export default revocateMessageHook;
